import { CanMatchFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { sessionSelectors } from '@store/session';
import { DialogService } from 'primeng/dynamicdialog';
import { AuthComponent } from '@app2/features/auth/auth.component';
import { InitStore } from '@app2/store/init/init.store';

export const authGuardFn: CanMatchFn = () => {
  const dialogService = inject(DialogService);
  const router = inject(Router);
  const store = inject(Store);
  const initStore = inject(InitStore);
  const isSetUser = store.selectSignal(sessionSelectors.selectIsSetUser);
  const isInitialNavigation = !router.navigated;

  const clickId = new URLSearchParams(document.location.search).get('subid');

  if (clickId) {
    localStorage.setItem('clickId', clickId);
  }

  if (isSetUser()) {
    return true;
  }

  if (!initStore.isUserSetAdult()) {
    initStore.setPendingAuthDialog(true);
  } else {
    dialogService.open(AuthComponent, {
      header: undefined,
      showHeader: false,
      modal: true,
      dismissableMask: true,
      transitionOptions: '.3s ease-in-out',
    });
  }

  if (isInitialNavigation) {
    // Явный редирект, чтобы не получить пустой экран на прямой ссылке
    return router.createUrlTree(['/']);
  }
  return false;
};
